import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<FiltersComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  filterData: any[] = [];
  service: any;
  currentTab: any;
  isPractDistanceOver20km: boolean;
  initialTab: any;
  visibleOptionsCounts: { [key: string]: number } = {};

  ngOnInit(): void {
    this.filterData = [...this.data.filters.map((item: any) => ({ ...item, visibleCount: 4 }))];
    this.service = this.data?.service;
    this.isPractDistanceOver20km = this.data?.isPractDistanceOver20km;
    this.currentTab = this.data?.tab;
    this.initialTab = this.data?.tab;
  }

  toggleBookingType(tab: 'In Person' | 'Online') {
    this.currentTab = tab;
  }

  filterDataByTab() {
    return this.filterData;
  }

  isApplied(): boolean {
    const isFiltersChanged = this.filterData.some(
      (filter) =>
        (Array.isArray(filter.value) && filter.value.length > 0) ||
        (typeof filter.value === 'string' && filter.value.trim() !== '')
    );

    const isTabChanged = this.currentTab !== this.initialTab;

    return isFiltersChanged || isTabChanged;
  }

  closeModal() {
    this.dialogRef.close();
  }

  toggleOptionsVisibility(item: any): void {
    item.showAllOptions = !item.showAllOptions;

    if (item.showAllOptions) {
      this.showAllOptions(item);
    } else {
      this.showLessOptions(item);
    }
  }

  getVisibleOptions(options: string[], visibleCount: number, showAllOptions: boolean): string[] {
    if (showAllOptions) {
      return options;
    } else {
      return options?.slice(0, visibleCount);
    }
  }

  showAllOptions(item: any): void {
    this.visibleOptionsCounts[item.function] = item.options.length;
  }

  showLessOptions(item: any): void {
    item.visibleCount = 4;
    this.visibleOptionsCounts[item.function] = 4;
  }

  getCheckboxValue(option: string, filter: any): void {
    const index = filter.value.indexOf(option);
    if (index > -1) {
      filter.value.splice(index, 1);
    } else {
      filter.value.push(option);
    }
  }

  clearAll() {
    this.filterData.forEach((filter: any) => {
      if (filter.type === 'radio') {
        filter.value = '';
      } else {
        filter.value = [];
      }
    });
    const payload = {
      filters: this.filterData,
      currentTab: this.currentTab
    };
    this.dialogRef.close(payload);
  }

  apply() {
    const payload = {
      filters: this.filterData,
      currentTab: this.currentTab
    };
    this.dialogRef.close(payload);
  }
}
